import { render, staticRenderFns } from "./FuelTripAllowance.vue?vue&type=template&id=33b0ac35"
import script from "./FuelTripAllowance.vue?vue&type=script&lang=js"
export * from "./FuelTripAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports